import { useSettings } from "../../toolympus/api/useSettings"
import { useLocalizedRecord } from "../../toolympus/components/LocalizedRecords";
import { MenuItem } from "../../toolympus/components/primitives/BasicMenuEditor";
import { DefaultLanguage } from "../Localization";

interface SiteSettings {
    menu: [];
    header_menu: {
      primary: MenuItem[];
      secondary: MenuItem[];
    };
    translations: any;
}

export const useSiteSettingsEdit = () => {
    const data = useSettings<SiteSettings>("/api/site-settings", { menu: [], header_menu: { primary: [], secondary: [] }, translations: {} });
    const localized = useLocalizedRecord(data.settings, {
        defaultLocale: DefaultLanguage,
        translatedFields: ["menu", "header_menu"],
        translationsField: "translations",
        updateItem: (o,c) => data.update(c),
    });

    return {
        ...data,
        ...localized,
        update: localized.updateItem,
    }
}
